import { resetLocalAndSessionStores } from 'helpers/resetLocalAndSessionStores'
import { useEffect } from 'react'
import { useShallow } from 'zustand/shallow'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandStore } from 'zustandGlobalStore'

export const useCleanDataByCohortChange = (): void => {
  const { cohort } = useZustandStore(
    useShallow((state) => ({
      cohort: state.lead?.cohort || '',
    })),
  )
  const { previousCohort } = useZustandGlobalLocalStore(
    useShallow((state) => ({
      previousCohort: state.previousCohort,
    })),
  )

  useEffect(() => {
    const isCohortChanging =
      cohort && previousCohort && cohort !== previousCohort

    if (isCohortChanging) {
      resetLocalAndSessionStores()
      useZustandGlobalLocalStore.setState({
        previousCohort: cohort,
      })
    }
  }, [cohort, previousCohort])
}
